import WindowLib from '@/lib/windowLib/WindowLib'
import { onMounted, onUnmounted } from 'vue'
import { Toast } from 'vant'

/**
 * NFC 读取 Hook
 * 原生 App 监听到 NFC 标签后，会调用挂在 window 上的 getNfcDataNativeFn，
 * 把识别到的码内容（params）传进 Web 页面。
 *
 * @param {(params: string|number) => void} callback 原生读到标签后回调，params 即码内容
 *
 * 使用示例：
 *   useNfc((params) => {
 *     form.value.code_sn = params       // 把码写入表单
 *     onSubmit()                       // 触发业务提交
 *   })
 */
export const useNfc = callback => {
  const winLib = new WindowLib()

  // 原生约定的回调名：getNfcData（挂到 window 后为 getNfcDataNativeFn）
  function getNfcData(params) {
    if (!params) {
      return Toast.fail('nfc获取的数据为空')
    }
    callback && callback(params)
  }

  onMounted(() => {
    winLib.addAttr('getNfcData', getNfcData)
  })

  onUnmounted(() => {
    winLib.removeAttr('getNfcData', getNfcData)
  })

  return {}
}
